const prefix = '/value-chain-maps/supplier';

export const VC_SUPPLIER_LIST_TAG = `${prefix}`;
export const VC_SUPPLIER_RECORD_TAG = `${prefix}/{id}`;

export default VC_SUPPLIER_LIST_TAG;
